import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TTimeFormat } from '../model/date.types';
import { DateUtil } from '../services';

@Pipe({
  name: 'toTime',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class ToTimePipe implements PipeTransform {
  constructor() {}

  transform(value: string, format: TTimeFormat = 'HH:MM'): string {
    const formatted = DateUtil.formatTime(value, format);
    return formatted;
  }
}
